import React, { useContext } from 'react'
import { Row, Col, Card, Button, Badge } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ThemeContext } from '../components/ThemeContext.js'

const PremiumScreen = () => {
  const { theme } = useContext(ThemeContext)
  const navigate = useNavigate()

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  if (!userInfo) {
    navigate('/login')
    return null
  }

  const cardStyle = {
    backgroundColor: theme.cardBackground || theme.background,
    border: `1px solid ${theme.accent}`,
    height: '100%'
  }

  const accentBtn = {
    borderColor: theme.accent,
    color: theme.accent,
    backgroundColor: 'transparent'
  }

  // Placeholder tiers — features to be defined
  const tiers = [
    {
      name: 'Free',
      price: '$0 / mo',
      current: true,
      features: [
        'Receipt storage',
        'QR code access',
        'Basic dashboard',
        'Category tagging'
      ],
      cta: 'Current Plan',
      disabled: true
    },
    {
      name: 'Premium',
      price: 'TBD',
      current: false,
      features: [
        'Everything in Free',
        'Advanced analytics',
        'Extended receipt history',
        'Priority support',
        'Coming soon — more features'
      ],
      cta: 'Upgrade — Coming Soon',
      disabled: true
    }
  ]

  return (
    <div style={{ color: theme.text }}>
      <h2 style={{ color: theme.accent }} className='mb-1'>
        Premium Services
      </h2>
      <p className='text-muted mb-4'>
        Choose the plan that works for you. Premium features are currently in
        development.
      </p>

      <Row className='g-4 mb-5'>
        {tiers.map((tier) => (
          <Col key={tier.name} md={4}>
            <Card style={cardStyle}>
              <Card.Body className='d-flex flex-column'>
                <div className='mb-3'>
                  <Card.Title style={{ color: theme.accent }}>
                    {tier.name}{' '}
                    {tier.current && (
                      <Badge bg='secondary' style={{ fontSize: '0.7rem' }}>
                        Active
                      </Badge>
                    )}
                  </Card.Title>
                  <h4 style={{ color: theme.text }}>{tier.price}</h4>
                </div>

                <ul className='list-unstyled flex-grow-1 mb-4'>
                  {tier.features.map((f) => (
                    <li key={f} className='mb-1' style={{ fontSize: '0.9rem' }}>
                      <span style={{ color: theme.accent, marginRight: '8px' }}>
                        ✓
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>

                <Button
                  variant='outline-primary'
                  style={accentBtn}
                  disabled={tier.disabled}
                >
                  {tier.cta}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row>
        <Col md={8}>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title style={{ color: theme.accent }}>
                What's Coming
              </Card.Title>
              <p style={{ fontSize: '0.9rem' }} className='text-muted'>
                We're building premium features based on user feedback. If you
                have a feature request, let us know via the{' '}
                <span
                  style={{ color: theme.accent, cursor: 'pointer' }}
                  onClick={() => navigate('/contact')}
                >
                  contact page
                </span>
                .
              </p>
              <ul style={{ fontSize: '0.9rem' }}>
                <li>Advanced receipt analytics and export</li>
                <li>Extended storage and search history</li>
                <li>Warranty and return date tracking</li>
                <li>Multi-device QR sharing</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default PremiumScreen
